const validateRequired = (value, message) => {
  const isAccepted = !!value.trim();

  return isAccepted || message;
};

export default validateRequired;
